import React, { useEffect, useState } from "react";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import clientConfig from "../../env";
import axios from "axios";
import { CiCircleMinus, CiCirclePlus } from "react-icons/ci";

const eventsData = [
  {
    date: "Oct 15, 2024",
    topics: [
      {
        title: "Developing an Effective Exit Strategy",
        votes: 9999,
        voted: true,
      },
      { title: "Overcoming Business Challenges", votes: 19, voted: false },
      { title: "Customer Retention Strategies", votes: 9, voted: false },
    ],
  },
  {
    date: "Oct 08, 2024",
    topics: [
      {
        title:
          "Exploring New Markets, Expansion Opportunities, and Enhancing Cybersecurity for Small Businesses",
        votes: 34,
        voted: true,
      },
      { title: "Overcoming Business Challenges", votes: 19 },
      { title: "Customer Retention Strategies", votes: 9 },
    ],
  },
  {
    date: "Oct 01, 2024",
    topics: [
      {
        title: "Leveraging Data and Analytics for Business Growth",
        votes: 49,
        voted: true,
      },
      { title: "Overcoming Business Challenges", votes: 19, voted: false },
      { title: "Customer Retention Strategies", votes: 9, voted: false },
      { title: "Effective Social Media Marketing", votes: 4, voted: false },
      { title: "Scaling Your Business", votes: 3, voted: false },
    ],
  },
  {
    date: "Sept 24, 2024",
    topics: [
      {
        title: "Building a Referral Program that Works",
        votes: 40,
        voted: true,
      },
    ],
  },
  {
    date: "Sept 17, 2024",
    topics: [
      {
        title: "Utilizing Freelancers and Contractors to Scale",
        votes: 34,
        voted: true,
      },
    ],
  },
];

const ITEMS_PER_PAGE = 10;

// Pagination Component
const Pagination = ({ totalPages, currentPage, setCurrentPage }) => {
  const maxVisiblePages = 5; // how many page buttons to show at once
  const startPage = Math.max(
    1,
    currentPage - Math.floor(maxVisiblePages / 2)
  );
  const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

  const pages = [];
  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  return (
    <nav>
      <ul className="pagination justify-content-center">
        {/* Prev Button */}
        <li className={`page-item mx-1 ${currentPage === 1 ? "disabled" : ""}`}>
          <button
            style={{ width: 40, height: 40 }}
            className="page-link rounded-circle d-flex align-items-center"
            onClick={() => setCurrentPage(currentPage - 1)}
          >
            <MdKeyboardArrowLeft />
          </button>
        </li>

        {/* Show first page if hidden */}
        {startPage > 1 && (
          <>
            <li className="page-item mx-1">
              <button
                style={{ width: 40, height: 40 }}
                className="page-link rounded-circle"
                onClick={() => setCurrentPage(1)}
              >
                1
              </button>
            </li>
            <li className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          </>
        )}

        {/* Visible Page Numbers */}
        {pages.map((page) => (
          <li
            key={page}
            className={`page-item mx-1 ${currentPage === page ? "active" : ""}`}
          >
            <button
              style={{ width: 40, height: 40 }}
              className="page-link rounded-circle"
              onClick={() => setCurrentPage(page)}
            >
              {page}
            </button>
          </li>
        ))}

        {/* Show last page if hidden */}
        {endPage < totalPages && (
          <>
            <li className="page-item mx-1 disabled">
              <span className="page-link">...</span>
            </li>
            <li className="page-item mx-1">
              <button
                style={{ width: 40, height: 40 }}
                className="page-link rounded-circle"
                onClick={() => setCurrentPage(totalPages)}
              >
                {totalPages}
              </button>
            </li>
          </>
        )}

        {/* Next Button */}
        <li
          className={`page-item mx-1 ${
            currentPage === totalPages ? "disabled" : ""
          }`}
        >
          <button
            style={{ width: 40, height: 40 }}
            className="page-link rounded-circle d-flex align-items-center"
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            <MdKeyboardArrowRight />
          </button>
        </li>
      </ul>
    </nav>
  );
};

function PreviousEventsPopup({ open }) {
  const [expandedRow, setExpandedRow] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [allEvents, setAllEvents] = useState([]);
  const [currentEvents, setCurrentEvents] = useState([]);
  const [totalPages, setTotalPages] = useState();

  const toggleExpand = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };

  const getPreviousEventsList = async() => {
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const response = await axios.get(
        `${clientConfig.siteUrl}wl/v1/previous-week-events`,
        { headers: headers }
      );

      if(response.data.length) {
        const eventsData = response.data;
        console.log(eventsData);
        // const indexOfLast = currentPage * ITEMS_PER_PAGE;
        // const indexOfFirst = indexOfLast - ITEMS_PER_PAGE;
        // const currentEvents = eventsData.slice(indexOfFirst, indexOfLast);

        const totalPages = Math.ceil(eventsData.length / ITEMS_PER_PAGE);
        setAllEvents(eventsData);
        setTotalPages(totalPages);
      } else {
        setCurrentEvents([]);
        setTotalPages(1);
      }
    } catch(error) {
      console.error(error);
    }
  }

  useEffect(() => {
    // slice data for current page
    const indexOfLast = currentPage * ITEMS_PER_PAGE;
    const indexOfFirst = indexOfLast - ITEMS_PER_PAGE;
    const paginatedData = [...allEvents].slice(indexOfFirst, indexOfLast);
    console.log(paginatedData);
    setCurrentEvents(paginatedData);
    setExpandedRow(null);
  }, [currentPage, allEvents]);

  useEffect( () => {
    getPreviousEventsList();
  }, [])



  return (
    <div
      className={`modal fade ${open ? "show" : ""}`}
      id="previousEvents"
      tabIndex="-1"
    >
      <div className="modal-dialog modal-xl modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Previous Events & Topics</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body text-left">
            <table className="table table-borderless">
              <thead className="border-bottom">
                <tr>
                  <th width="200px">Date</th>
                  <th>Events / Topic</th>
                  <th width="200px">Votes</th>
                </tr>
              </thead>
              <tbody>
                {currentEvents.map((event, i) => (
                  <React.Fragment key={i}>
                    <tr>
                      <td className="py-2">{event.date}</td>
                      <td className="py-2">{event.topics[0].title}</td>
                      <td className="py-2 d-flex justify-content-between">
                        {event.topics[0].votes} Voted{" "}
                        {event.topics.length > 1 && (
                          <span
                            style={{ cursor: "pointer"}}
                            className="ml-2 px-2"
                            onClick={() => toggleExpand(i)}
                            d-flex justify-content-between
                          >
                            {expandedRow !== i ? (
                              <CiCirclePlus size={25} />
                            ) : (
                              <CiCircleMinus size={25} />
                            )}
                          </span>
                        )}
                      </td>
                    </tr>

                    {expandedRow === i && event.topics.length > 1 && (
                      <tr>
                        <td></td>
                        <td colSpan="2" className="pt-0">
                          <div className="accordion">
                            {event.topics.slice(1).map((topic, j) => (
                              <div
                                key={j}
                                className="d-flex justify-content-between border-0 py-2"
                              >
                                <span>{topic.title}</span>
                                <span style={{ width: 176 }}>
                                  {topic.votes} Voted
                                </span>
                              </div>
                            ))}
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>

            {/* Improved Pagination */}
            <Pagination
              totalPages={totalPages}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PreviousEventsPopup;
